var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "openrouter-channel-detail" } },
    [
      _c("AppBreadCrumb", {
        attrs: {
          paths: [
            { title: _vm.$t("message.integrations"), route: "integrations" },
            {
              title: _vm.providerName,
              route: "integrations/openrouter/" + _vm.provider,
            },
            { title: _vm.channel ? _vm.channel.name : "" },
          ],
          select: true,
        },
      }),
      _vm._v(" "),
      _vm.channel
        ? _c(
            "div",
            { staticClass: "route-page-content breadcrumb-content" },
            [
              _c("SidebarChild", {
                attrs: {
                  items: _vm.menuItems,
                  "selected-item": _vm.currentTab,
                  focusActive: true,
                },
                on: {
                  selected: function (i) {
                    return (_vm.currentTab = i.key)
                  },
                },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "page-content-wrapper" }, [
                _c("div", { staticClass: "toolbar" }, [
                  _c(
                    "div",
                    { staticClass: "left" },
                    [
                      _c("IconButton", { attrs: { "on-click": _vm.goBack } }, [
                        _c("span", { staticClass: "material-icons" }, [
                          _vm._v("chevron_left"),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "icon-container" }, [
                        _c("img", {
                          attrs: {
                            src: _vm.providerLogo,
                            alt: _vm.providerName,
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "name" }, [
                        _vm._v(_vm._s(_vm.channel.name)),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "right" },
                    [
                      _c(
                        "a-button",
                        {
                          attrs: { type: "danger" },
                          on: {
                            click: function ($event) {
                              _vm.deleteModal = true
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("auto.openRouterDeleteChannel")) +
                              "\n                    "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _vm.currentTab === "detail"
                  ? _c(
                      "div",
                      [
                        _c("UpdateDetail", {
                          on: { saved: _vm.refreshChannel },
                          model: {
                            value: _vm.channel,
                            callback: function ($$v) {
                              _vm.channel = $$v
                            },
                            expression: "channel",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentTab === "visibility"
                  ? _c(
                      "div",
                      [
                        _c("Visibility", {
                          on: { saved: _vm.refreshChannel },
                          model: {
                            value: _vm.channel,
                            callback: function ($$v) {
                              _vm.channel = $$v
                            },
                            expression: "channel",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
            ],
            1
          )
        : _c("div", { staticClass: "loading" }, [_c("a-spin")], 1),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: {
            icon: "exclamation-circle",
            title: _vm.$t("message.deleteConfirm") || "Kanalı Sil",
          },
          on: {
            cancel: function ($event) {
              _vm.deleteModal = false
            },
          },
          scopedSlots: _vm._u([
            {
              key: "footer",
              fn: function () {
                return [
                  _c(
                    "a-button",
                    {
                      key: "back",
                      on: {
                        click: function ($event) {
                          _vm.deleteModal = false
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("message.cancel")) +
                          "\n            "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-button",
                    {
                      key: "submit",
                      attrs: { type: "danger" },
                      on: { click: _vm.handleDeleteChannel },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("chatbotv2.delete")) +
                          "\n            "
                      ),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
          model: {
            value: _vm.deleteModal,
            callback: function ($$v) {
              _vm.deleteModal = $$v
            },
            expression: "deleteModal",
          },
        },
        [
          _c("p", [
            _vm._v(
              _vm._s(
                _vm.$t("message.deleteChannelConfirm") ||
                  "Bu kanalı silmek istediğinize emin misiniz?"
              )
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }